import { jsx as _jsx } from "react/jsx-runtime";
import { Listbox as HeroListbox } from '@heroui/react';
export const Listbox = (props) => {
    return _jsx(HeroListbox, { ...props });
};
export default Listbox;
//# sourceMappingURL=Listbox.js.map